export default __webpack_public_path__ + "static/portfolio-19-a166da14f9c58589952b87ab6268c683.jpg";